import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const NewDistrict = ({ show, setShow, dispatchDistricts, socket }) => {

    const handleClose = () => setShow(false);

    const [districtNumber, setDistrictNumber] = useState(0);

    const handleSubmit = () => {
        socket.emit('districts', { type: 'create', number: districtNumber, ip: localStorage.getItem('ip') });
        socket.on('districts', data => {
            dispatchDistricts(data);
            setShow(false);
        });
    }

    return (
        <Dialog open={show} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>New Repeater</DialogTitle>
            <DialogContent>
                <TextField
                    label="District Number"
                    type="number"
                    slotProps={{ htmlInput: { max: 8 } }}
                    defaultValue={districtNumber}
                    onChange={e => setDistrictNumber(e.target.value)}
                    fullWidth
                    sx={{ mt: 1 }}
                />
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="error" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="contained" color="success" onClick={handleSubmit}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewDistrict
